module.exports = __webpack_public_path__ + "static/media/profile_kazehayasho5fd6ed711e29c42de52297f616659883.webp";